export default __webpack_public_path__ + "static/media/facebook_comment.70d07673.svg";